<script setup lang="ts">
interface Props {
  title?: string;
  description?: string;
  backLink?: { name: string } | string;
}

defineProps<Props>();
</script>

<template>
  <v-container fluid>
    <v-row v-if="backLink">
      <v-col>
        <v-btn variant="text" :to="backLink" color="primary">
          <v-icon class="mr-1">fa fa-arrow-left</v-icon>
          Back
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="title">
      <v-col cols="auto">
        <h1 class="text-primary font-weight-bold text-h3">{{ title }}</h1>
        <span>{{ description }}</span>
      </v-col>
      <v-spacer/>
      <v-col cols="auto" class="text-right" align-self="center">
        <slot name="actions"/>
      </v-col>
    </v-row>
    <slot></slot>
  </v-container>
</template>

<style scoped>

</style>
